/** Object representing an empty one-to-many relationship in JSON:API */
export const EMPTY_TO_MANY = {
  data: [],
}
